import { sql } from 'drizzle-orm';
import {
  pgTable,
  index,
  jsonb,
  timestamp,
  varchar,
  text,
  boolean,
  uuid,
  primaryKey
} from "drizzle-orm/pg-core";
import { organizations } from './organizations';
import { users } from './users';

// ============================================
// In-App Notifications
// ============================================

export const notifications = pgTable("notifications", {
  id: uuid("id").primaryKey().default(sql`gen_random_uuid()`),
  userId: varchar("user_id").references(() => users.id, { onDelete: "cascade" }).notNull(),
  type: varchar("type").notNull(), // 'document_processed', 'document_failed', 'task_assigned', etc.
  title: varchar("title").notNull(),
  message: text("message"),
  isRead: boolean("is_read").default(false),
  deepLink: varchar("deep_link"), // e.g. '/claims/abc123?tab=files'
  entityType: varchar("entity_type"), // 'document', 'claim', 'task'
  entityId: varchar("entity_id"),
  metadata: jsonb("metadata"), // { fileName, status, claimNumber, ... }

  orgId: uuid("org_id").references(() => organizations.id, { onDelete: "cascade" }),

  createdAt: timestamp("created_at").defaultNow(),
  readAt: timestamp("read_at"),
}, (table) => [
  index("idx_notifications_user_id").on(table.userId),
  index("idx_notifications_user_read").on(table.userId, table.isRead),
  index("idx_notifications_created_at").on(table.createdAt),
  index("idx_notifications_entity").on(table.entityType, table.entityId),
]);

export const emailLinkedDigestTracking = pgTable("email_linked_digest_tracking", {
  userId: varchar("user_id").primaryKey().references(() => users.id, { onDelete: "cascade" }),
  lastDigestSentAt: timestamp("last_digest_sent_at"),
  orgId: uuid("org_id").references(() => organizations.id, { onDelete: "cascade" }),
  updatedAt: timestamp("updated_at").defaultNow(),
});
